<template>
  <h4>Hotel Checkout Time</h4>
  <div class="form-check form-switch d-flex align-items-center gap-2 ps-0 mb-2">
    <label
        class="form-check-label"
        for="is-hotel-checkout-time-enabled"
    >
      Enable Checkout Time
    </label>
    <input
        v-model="isCheckoutTimeEnabled"
        class="form-check-input m-0"
        type="checkbox"
        role="switch"
        id="is-hotel-checkout-time-enabled"
        @click="handleCheckoutTimeEnabledChange"
    />
  </div>
  <div class="mb-2">
    <label
        for="hotel-checkout-time"
        class="form-label"
    >
      Checkout Time
    </label>
    <input
        type="time"
        class="form-control width-20-per"
        id="hotel-checkout-time"
        :disabled="!isCheckoutTimeEnabled"
        v-model="checkoutTime"
        @change="handleCheckoutTimeChange"
    >
  </div>

  <h4>Hotel Billing</h4>
  <div class="form-check form-switch d-flex align-items-center gap-2 ps-0 mb-2">
    <label
        class="form-check-label"
        for="full-hotel-bill-during-check-in"
    >
      Full Hotel Bill During Check In
    </label>
    <input
        v-model="fullBillDuringCheckIn"
        class="form-check-input m-0"
        type="checkbox"
        role="switch"
        id="full-hotel-bill-during-check-in"
        @click="handleFullBillDuringCheckInChange"
    />
  </div>

  <GlobalLoader />
</template>

<script setup>
import {inject, onMounted, ref} from "vue";
import handleCompany from "@/services/modules/company";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {getPreferenceValue, parsePreferenceBoolean} from "@/services/utils/global";

const isCheckoutTimeEnabled = ref(false)
const checkoutTime = ref(null)
const fullBillDuringCheckIn = ref(false)
const { getCompanyPreferences, modifyCompanyPreference } = handleCompany();
const $store = useStore();
const $route = useRoute();
const showSuccess = inject('showSuccess');
const companyId = $route.params.companyId;

const toPreferenceFlag = (checked) => {
    if (! checked) return "0";
    return "1";
}

const handleCheckoutTimeEnabledChange = (e) => {
    const nextValue = e.target.checked;

    const data = {
        company_id: companyId,
        field: "is_hotel_checkout_time_enabled",
        value: toPreferenceFlag(nextValue),
    };

    handleUpdate(data);
}

const handleCheckoutTimeChange = (e) => {
    const nextValue = e.target.value;

    if (! nextValue) return

    const data = {
        company_id: companyId,
        field: "hotel_checkout_time",
        value: nextValue,
    };

    handleUpdate(data);
}

const handleFullBillDuringCheckInChange = (e) => {
    const nextValue = e.target.checked;

    const data = {
        company_id: companyId,
        field: "full_hotel_bill_during_check_in",
        value: toPreferenceFlag(nextValue),
    };

    handleUpdate(data);
}

const handleUpdate = (data) => {
    $store.state.loading = true;

    modifyCompanyPreference(data)
        .then((res) => {
            showSuccess(res.message);
        })
        .finally(() => ($store.state.loading = false));
}

onMounted(() => {
    $store.state.loading = true

    const queryObject = {
        company_id: companyId,
        fields: 'is_hotel_checkout_time_enabled,hotel_checkout_time,full_hotel_bill_during_check_in'
    }
    const query = '?' + new URLSearchParams(queryObject).toString();

    getCompanyPreferences(query)
        .then(res => {
            if (res.data) {
                const data = res.data;
                isCheckoutTimeEnabled.value = parsePreferenceBoolean(getPreferenceValue(data, 'is_hotel_checkout_time_enabled'))
                checkoutTime.value = getPreferenceValue(data, 'hotel_checkout_time')
                fullBillDuringCheckIn.value = parsePreferenceBoolean(getPreferenceValue(data, 'full_hotel_bill_during_check_in'))
            }
        })
        .finally(() => $store.state.loading = false);
});
</script>
